import { z } from 'zod'

export const WEEKLY_STRATEGIES = ['blended', 'descending', 'ascending'] as const

export type WeeklyStrategy = (typeof WEEKLY_STRATEGIES)[number]

export const WEEKLY_STRATEGY_LABELS: Record<WeeklyStrategy, string> = {
  blended: 'Mélange',
  descending: 'Descendante',
  ascending: 'Montante',
}

export const weeklySearchSchema = z.object({
  tab: z.enum(['forecast', 'backtest']).default('forecast'),
  storeIds: z.array(z.number()).default([]),
  spanWeeks: z.number().min(8).max(130).default(84),
  everyWeeks: z.number().min(1).max(13).default(4),
  weeks: z.number().min(1).max(52).default(52),
  corrections: z.boolean().default(false),
  strategy: z.enum(WEEKLY_STRATEGIES).default('blended'),
  anchor: z.string().optional(),
})

export type WeeklySearch = z.infer<typeof weeklySearchSchema>
